import { Minus, Plus } from "lucide-react";
import React from "react";

const BlogDetailsFAQs = ({ faqs }) => {
  return (
    <section className="bg-white rounded-2xl border border-gray-200 p-5">
      <div className="grid grid-cols-1 gap-4 lg:grid-cols-12 lg:items-start lg:gap-6">
        <div className="lg:col-span-4">
          <h2 className="font-bold lg:font-semibold text-gray-900 lg:text-black leading-tight">
            Frequently Asked Questions
          </h2>
          <p className="mt-2 text-sm text-gray-600">
            Got questions? We've got answers. Explore everything you need to
            know in one place.
          </p>
        </div>

        <div className="lg:col-span-8">
          {faqs.length ? (
            <div className="space-y-3">
              {faqs.map((f, i) => (
                <details
                  key={i}
                  className="group bg-[#EFEFEF] rounded-xl px-5 py-4"
                >
                  <summary className="cursor-pointer list-none flex items-center justify-between gap-4">
                    <span className="span-text font-semibold text-black">
                      {f.q}
                    </span>
                    <span className="relative h-5 w-5 lg:h-7 lg:w-7 shrink-0 rounded-full bg-[#FBBC05] text-black flex items-center justify-center font-bold leading-none">
                      {/* Horizontal line (Minus) - visible always */}
                      <span className="absolute w-2.5 h-[2px] lg:w-3 lg:h-0.5 bg-black rounded-full" />
                      {/* Vertical line (to form Plus) - hidden when open */}
                      <span className="absolute w-[2px] h-2.5 lg:w-0.5 lg:h-3 bg-black rounded-full group-open:hidden" />
                    </span>
                  </summary>
                  <p className="mt-3 text-sm text-gray-700 leading-relaxed">
                    {f.a}
                  </p>
                </details>
              ))}
            </div>
          ) : (
            <p className="text-sm text-gray-500">
              No questions and answers have been added for this article yet.
            </p>
          )}
        </div>
      </div>
    </section>
  );
};

export default BlogDetailsFAQs;
